// Global application links
export const EXTERNAL_LINKS = {
  GOOGLE_PLAY_STORE: 'https://play.google.com/store/apps/details?id=com.owclient',
  APP_STORE: 'https://apps.apple.com/gb/app/ow-client/id6762087272',
  FACEBOOK: 'https://facebook.com/owclient',
  DOWNLOAD: '/download',
};

export const OWNER_API_URL = process.env.REACT_APP_OWNER_API_URL;
export const NOTIFY_API_URL = process.env.REACT_APP_NOTIFY_API_URL;
export const PAYMENT_API_URL = process.env.REACT_APP_PAYMENT_API_URL;
export const CLIENT_API_URL = process.env.REACT_APP_CLIENT_API_URL;

// Logo URLs — single source of truth (served from ow-fe public)
export const LOGO_CLIENT_URL = 'https://www.ow-client.com/images/ow-client-logo.png';
export const LOGO_OWNER_URL = 'https://www.ow-client.com/images/ow-owner-logo.png';

